module.exports = __webpack_public_path__ + "img/magazine58.7a300a07.jpg";